import React from 'react';
import { portalCopy } from '../copy';

type WizardProgressProps = {
  currentStep: number;
};

const WizardProgress: React.FC<WizardProgressProps> = ({ currentStep }) => (
  <ol className="flex flex-wrap gap-2 sm:gap-3" aria-label="Progreso del registro">
    {portalCopy.wizard.steps.map((label, index) => {
      const step = index + 1;
      const isActive = step === currentStep;
      const isDone = step < currentStep;

      return (
        <li
          key={label}
          className={`flex items-center gap-2 rounded-full px-3 py-1.5 font-jakarta text-xs font-semibold sm:text-[13px] ${
            isActive
              ? 'bg-chisme-primary text-white'
              : isDone
                ? 'bg-chisme-primary/15 text-chisme-primary'
                : 'bg-[rgba(74,33,71,0.06)] text-[#5a3158]'
          }`}
        >
          <span className="tabular-nums">{step}</span>
          <span>{label}</span>
        </li>
      );
    })}
  </ol>
);

export default WizardProgress;
